/* Centilmen — Aksesuarda %10 ekstra indirim önerisi
   Sepete ekleme pencerelerinde ve sepet sayfasında indirimli aksesuar önerir.
   İndirimin kendisi Shopify otomatik indirimi ("2.000₺ Üzeri Aksesuarda %10 İndirim") ile uygulanır. */
(function () {
  'use strict';
  if (window.__cnafYuklendi) return;
  window.__cnafYuklendi = true;

  var KAYNAK = '/collections/aksesuar-firsati/products.json?limit=250';
  var ORAN = 0.10;
  var ESIK = 200000; // kuruş: 2.000₺
  var ONBELLEK = 'cntlAksFirsat_v3';
  var liste = null;
  var bekleyen = null;

  function tl(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
  }
  function kacis(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function kucuk(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }
  function karistir(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function aksesuarlar() {
    if (liste) return Promise.resolve(liste);
    if (bekleyen) return bekleyen;
    try {
      var c = JSON.parse(sessionStorage.getItem(ONBELLEK) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000 && c.d) { liste = c.d; return Promise.resolve(liste); }
    } catch (e) {}
    function sayfa(n, birikim) {
      return fetch(KAYNAK + '&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var u = j.products || [];
          birikim = birikim.concat(u);
          return (u.length === 250 && n < 4) ? sayfa(n + 1, birikim) : birikim;
        });
    }
    bekleyen = sayfa(1, [])
      .then(function (urunler) {
        liste = urunler.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; });
          return {
            id: p.id,
            handle: p.handle,
            baslik: p.title,
            marka: p.vendor,
            gorsel: p.images && p.images[0] ? p.images[0].src : '',
            varyant: v.length === 1 ? v[0].id : null,
            stok: v.length,
            fiyat: v.length ? Math.round(parseFloat(v[0].price) * 100) : 0
          };
        }).filter(function (p) { return p.stok > 0 && p.fiyat > 0; });
        try { sessionStorage.setItem(ONBELLEK, JSON.stringify({ t: Date.now(), d: liste })); } catch (e) {}
        return liste;
      })
      .catch(function () { liste = []; return liste; });
    return bekleyen;
  }

  function sepet() {
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function durum(cart, akslar) {
    var aksId = {};
    akslar.forEach(function (p) { aksId[p.id] = 1; });
    var d = { adet: 0, indirim: 0, sepette: {}, ara: cart.items_subtotal_price || cart.total_price || 0 };
    (cart.items || []).forEach(function (it) {
      d.sepette[it.product_id] = 1;
      d.adet += it.quantity;
      var bulundu = false;
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title || '';
        if (/aksesuar/i.test(t)) { d.indirim += a.amount; bulundu = true; }
      });
      if (!bulundu) {
        (it.discounts || []).forEach(function (x) { if (/aksesuar/i.test(x.title || '')) d.indirim += x.amount; });
      }
    });
    return d;
  }

  function kartHtml(p) {
    var yeni = Math.round(p.fiyat * (1 - ORAN));
    var buton = p.varyant
      ? '<button type="button" class="cnaf-ekle" data-cnaf-ekle="' + p.varyant + '">EKLE</button>'
      : '<a class="cnaf-ekle" href="/products/' + kacis(p.handle) + '">SEÇ</a>';
    return '<div class="cnaf-kart">' +
      '<a class="cnaf-gorsel" href="/products/' + kacis(p.handle) + '">' +
        (p.gorsel ? '<img src="' + kacis(kucuk(p.gorsel)) + '" alt="' + kacis(p.baslik) + '" loading="lazy">' : '') +
        '<span class="cnaf-rozet">%10</span>' +
      '</a>' +
      '<span class="cnaf-marka">' + kacis(p.marka) + '</span>' +
      '<a class="cnaf-ad" href="/products/' + kacis(p.handle) + '">' + kacis(p.baslik) + '</a>' +
      '<span class="cnaf-fiyat"><s>' + tl(p.fiyat) + '</s><b>' + tl(yeni) + '</b></span>' +
      buton +
    '</div>';
  }

  function blokHtml(d, akslar, adet) {
    if (!d.adet || !akslar.length) return '';
    var ust = '';
    if (d.indirim > 0) {
      ust = '<div class="cnaf-uygulandi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>' +
            '<span>Aksesuar indiriminiz uygulandı: <b>−' + tl(d.indirim) + '</b></span></div>';
    }
    var aday = karistir(akslar.filter(function (p) { return !d.sepette[p.id]; })).slice(0, adet);
    if (!aday.length) return ust;
    var alt = d.ara >= ESIK
      ? 'Sepetiniz 2.000₺\'yi geçti. Eklediğiniz aksesuarlara %10 indirim sepette otomatik uygulanır.'
      : '2.000₺ ve üzeri alışverişlerde aksesuarlarda %10 indirim sepette otomatik uygulanır.';
    return ust +
      '<div class="cnaf-oneri">' +
        '<div class="cnaf-bas"><span class="cnaf-ust">KOMBİNİNİ TAMAMLA</span>' +
        '<strong>2.000₺ üzeri alışverişte aksesuarlarda %10</strong><small>' + alt + '</small></div>' +
        '<div class="cnaf-kartlar" style="--cnaf-adet:' + aday.length + '">' + aday.map(kartHtml).join('') + '</div>' +
      '</div>';
  }

  function yerlestir(yer, konumla, adet) {
    return Promise.all([aksesuarlar(), sepet()]).then(function (s) {
      var akslar = s[0], cart = s[1];
      var d = durum(cart, akslar);
      var kutu = document.querySelector('.cnaf-kutu[data-cnaf-yer="' + yer + '"]');
      if (!kutu) {
        kutu = document.createElement('div');
        kutu.className = 'cnaf-kutu cnaf-kutu--' + yer;
        kutu.setAttribute('data-cnaf-yer', yer);
        if (!konumla(kutu)) return d;
      }
      kutu.innerHTML = blokHtml(d, akslar, adet);
      kutu.hidden = !kutu.innerHTML;
      return d;
    }).catch(function () {});
  }

  /* ---------- Yerleşim noktaları ---------- */

  // Ürün sayfası: "Sepetinize eklendi" penceresi
  function urunPenceresi() {
    return yerlestir('urun', function (kutu) {
      var liste = document.getElementById('lfnModalItemsList');
      if (!liste) return false;
      liste.insertAdjacentElement('afterend', kutu);
      return true;
    }, 3);
  }

  // Ana sayfa: sepete ekle açılır penceresi
  function anasayfaPenceresi() {
    return yerlestir('anasayfa', function (kutu) {
      var aks = document.querySelector('#lfnAtcPopupOverlay .lfn-atc-popup-actions');
      if (!aks) return false;
      aks.parentNode.insertBefore(kutu, aks);
      return true;
    }, 3);
  }

  // Sepet sayfası
  function sepetSayfasi() {
    return yerlestir('sepet', function (kutu) {
      var liste = document.getElementById('ctlItemsList');
      if (!liste) return false;
      liste.insertAdjacentElement('afterend', kutu);
      return true;
    }, 4).then(function (d) {
      if (!d) return;
      var kart = document.querySelector('#ctlSummarySection .ctl-summary-card');
      var form = kart && kart.querySelector('form#cart');
      var satir = document.getElementById('cnafOzetSatir');
      if (d.indirim > 0 && form) {
        if (!satir) {
          satir = document.createElement('div');
          satir.id = 'cnafOzetSatir';
          satir.className = 'cnaf-ozet';
          form.parentNode.insertBefore(satir, form);
        }
        satir.innerHTML = '<span>Aksesuar indirimi</span><b>−' + tl(d.indirim) + '</b><small>Toplam tutara yansıtıldı.</small>';
      } else if (satir) {
        satir.remove();
      }
    });
  }

  function sinifIzle(el, sinif, fn) {
    if (!el) return;
    var acik = el.classList.contains(sinif);
    if (acik) fn();
    new MutationObserver(function () {
      var simdi = el.classList.contains(sinif);
      if (simdi && !acik) setTimeout(fn, 60);
      acik = simdi;
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function baslat() {
    stilEkle();
    sinifIzle(document.getElementById('lfnCartModalBackdrop'), 'is-active', urunPenceresi);
    sinifIzle(document.getElementById('lfnAtcPopupOverlay'), 'active', anasayfaPenceresi);

    if (document.getElementById('ctlItemsList')) {
      sepetSayfasi();
      var toplam = document.getElementById('ctlGrandTotal');
      if (toplam) {
        var z;
        new MutationObserver(function () {
          clearTimeout(z);
          z = setTimeout(sepetSayfasi, 250);
        }).observe(toplam, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  /* ---------- Sepete ekleme ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-cnaf-ekle]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var kutu = b.closest('[data-cnaf-yer]');
    var yer = kutu ? kutu.getAttribute('data-cnaf-yer') : '';
    b.disabled = true;
    b.textContent = 'EKLENİYOR…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-cnaf-ekle'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('ekleme');
      return r.json();
    }).then(function () {
      b.textContent = 'EKLENDİ ✓';
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (x) {}
      if (yer === 'sepet') {
        window.location.reload();
      } else if (yer === 'urun') {
        setTimeout(function () { window.location.href = '/cart'; }, 400);
      } else {
        setTimeout(anasayfaPenceresi, 700);
      }
    }).catch(function () {
      b.disabled = false;
      b.textContent = 'TEKRAR DENE';
    });
  });

  function stilEkle() {
    if (document.getElementById('cnafStil')) return;
    var s = document.createElement('style');
    s.id = 'cnafStil';
    s.textContent =
      '.cnaf-kutu{margin:14px 0 16px;text-align:left;font-family:inherit}' +
      '.cnaf-kutu[hidden]{display:none}' +
      '.cnaf-uygulandi{display:flex;align-items:center;gap:8px;background:#eef6ee;color:#2e6b32;border-radius:6px;padding:10px 12px;font-size:12.5px;margin-bottom:10px}' +
      '.cnaf-uygulandi svg{width:16px;height:16px;flex:0 0 16px}' +
      '.cnaf-oneri{border:1px solid #e8e2da;background:#faf8f5;border-radius:6px;padding:14px}' +
      '.cnaf-bas{display:flex;flex-direction:column;gap:3px;margin-bottom:12px}' +
      '.cnaf-ust{font-size:9.5px;letter-spacing:.22em;font-weight:700;color:#b58d67}' +
      '.cnaf-bas strong{font-size:14.5px;font-weight:600;color:#1a1a1a}' +
      '.cnaf-bas small{font-size:11.5px;line-height:1.45;color:#6d5b52}' +
      '.cnaf-kartlar{display:grid;grid-template-columns:repeat(var(--cnaf-adet,3),minmax(0,1fr));gap:10px}' +
      '.cnaf-kart{display:flex;flex-direction:column;gap:3px;min-width:0;background:#fff;border-radius:4px;padding:8px}' +
      '.cnaf-gorsel{position:relative;display:block;aspect-ratio:1/1;background:#f3efe9;border-radius:3px;overflow:hidden;margin-bottom:4px}' +
      '.cnaf-gorsel img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}' +
      '.cnaf-rozet{position:absolute;top:6px;left:6px;background:#1a1a1a;color:#fff;font-size:9.5px;font-weight:700;padding:2px 6px;border-radius:2px;letter-spacing:.04em}' +
      '.cnaf-marka{font-size:9.5px;letter-spacing:.14em;font-weight:700;color:#8a7466;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.cnaf-ad{font-size:11.5px;line-height:1.3;color:#1a1a1a;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.6em}' +
      '.cnaf-fiyat{display:flex;flex-wrap:wrap;align-items:baseline;gap:0 6px;font-size:12px;margin:2px 0 6px}' +
      '.cnaf-fiyat s{color:#9a8f86;font-size:10.5px}' +
      '.cnaf-fiyat b{color:#1a1a1a;font-weight:700}' +
      '.cnaf-ekle{margin-top:auto;display:block;width:100%;box-sizing:border-box;text-align:center;background:#1a1a1a;color:#fff !important;border:1px solid #1a1a1a;border-radius:2px;padding:8px 4px;font-size:10.5px;font-weight:700;letter-spacing:.12em;cursor:pointer;text-decoration:none;font-family:inherit}' +
      '.cnaf-ekle:hover{background:#fff;color:#1a1a1a !important}' +
      '.cnaf-ekle:disabled{opacity:.7;cursor:default}' +
      '.cnaf-kutu--sepet{margin:22px 0 8px}' +
      '.cnaf-kutu--sepet .cnaf-oneri{padding:18px}' +
      '.cnaf-kutu--sepet .cnaf-bas strong{font-size:16px}' +
      '.cnaf-ozet{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:baseline;gap:2px 10px;padding:10px 0;margin:0 0 10px;border-top:1px dashed #e3dcd3;border-bottom:1px dashed #e3dcd3;font-size:13px;color:#2e6b32}' +
      '.cnaf-ozet small{flex-basis:100%;font-size:11px;color:#8a7466}' +
      '@media (max-width:600px){' +
        '.cnaf-kutu--sepet .cnaf-kartlar{grid-template-columns:repeat(2,minmax(0,1fr))}' +
        '.cnaf-kutu--sepet .cnaf-oneri{padding:14px}' +
      '}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
